const parseDateValue = (value: any): Date | undefined => {
	if (value === null || value === undefined || value === '') return undefined;

	if (value instanceof Date) {
		return Number.isNaN(value.getTime()) ? undefined : value;
	}

	const parsed = new Date(value);
	return Number.isNaN(parsed.getTime()) ? undefined : parsed;
};

const normalizeDateOnly = (value: Date) => {
	const normalized = new Date(value);
	normalized.setHours(0, 0, 0, 0);
	return normalized;
};

const validateByType = (value: any, field: any): string | undefined => {
	const { validationType, validationMessage, isMandatory } = field;

	const stringValue =
		value === null || value === undefined ? '' : value.toString().trim();

	if (isMandatory && stringValue === '') {
		return validationMessage || 'This field is required';
	}

	if (stringValue === '') return;

	switch ((validationType || '').toLowerCase()) {
		case 'numeric':
			if (!/^\d+$/.test(stringValue)) {
				return validationMessage || 'Only numbers allowed';
			}
			break;

		case 'alphabet':
			if (!/^[A-Za-z ]+$/.test(stringValue)) {
				return validationMessage || 'Only alphabets allowed';
			}
			break;

		case 'alphaspace':
			if (!/^[A-Za-z ]+$/.test(stringValue)) {
				return validationMessage || 'Only alphabets and spaces allowed';
			}
			break;

		case 'arabicspace':
			if (!/^[\u0600-\u06FF ]+$/.test(stringValue)) {
				return validationMessage || 'Only Arabic letters and spaces allowed';
			}
			break;

		case 'alphanumeric':
			if (!/^[A-Za-z0-9 ]+$/.test(stringValue)) {
				return validationMessage || 'Only letters & numbers allowed';
			}
			break;

		case 'nospecialchars':
			if (!/^[A-Za-z0-9 ]+$/.test(stringValue)) {
				return validationMessage || 'Special characters not allowed';
			}
			break;

		case 'email':
			if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(stringValue)) {
				return validationMessage || 'Invalid email';
			}
			break;

		case 'phone':
			if (!/^\+?\d+$/.test(stringValue)) {
				return validationMessage || 'Invalid phone number';
			}
			break;

		case 'alphanumericspecial':
			if (!/^[ A-Za-z0-9_@./#&+<>*!-]*$/.test(stringValue)) {
				return validationMessage || 'Invalid characters';
			}
			break;
		case 'alphaspacecomma':
			if (!/^[A-Za-z ,]*$/.test(stringValue)) {
				return (
					validationMessage || 'Only alphabets, spaces, and commas are allowed'
				);
			}
			break;

		case 'pastdate':
		case 'futuredate':
		case 'todayorpast':
		case 'todayorfuture': {
			const parsedDate = parseDateValue(value);
			if (!parsedDate) {
				return validationMessage || 'Invalid date';
			}

			const normalizedInput = normalizeDateOnly(parsedDate);
			const today = normalizeDateOnly(new Date());
			const type = validationType.toLowerCase();

			if (type === 'pastdate' && normalizedInput >= today) {
				return validationMessage || 'Today or future date not allowed';
			}

			if (type === 'futuredate' && normalizedInput <= today) {
				return validationMessage || 'Today or past date not allowed';
			}

			if (type === 'todayorpast' && normalizedInput > today) {
				return validationMessage || 'Future date not allowed';
			}

			if (type === 'todayorfuture' && normalizedInput < today) {
				return validationMessage || 'Past date not allowed';
			}
			break;
		}

		default:
			break;
	}

	return;
};

export default validateByType;
